<script>
  import CategoryBarVis from '../components/CategoryBarVis.svelte';
  import { isoLookup } from '../utils';

  const tooltipWidth = 250;

  const mapWrapper = document.querySelector('.koromap');
  const bounds = mapWrapper.getBoundingClientRect();
  let scrollY = 0;

  $: offset = { left: bounds.left, top: bounds.top - scrollY };

  $: left =
    position.x < window.innerWidth / 1.5
      ? position.x - offset.left
      : position.x - tooltipWidth - offset.left;

  $: top = position.y - offset.top;

  export let isoCode;
  export let position;
</script>

<style>
  .km-tooltip {
    position: absolute;
    padding: 10px;
    pointer-events: none;
    background: #fff;
    border: 1px solid #f3f3f3;
    box-shadow: 0 5px 20px -1px rgba(0, 0, 0, 0.06);
    border-radius: 5px !important;
    font-size: 14px;
    width: 200px;
    transform: translate(10px, 20px);
    user-select: none;
    z-index: 2;
  }

  .km-title {
    font-weight: 700;
    font-size: 15px;
    font-family: 'axiforma', Arial, sans-serif;
  }
</style>

<svelte:window scrollY={y} />

<div
  class="km-tooltip"
  style={`width: ${tooltipWidth}px; left: ${left}px;top: ${top}px`}>
  <div class="km-title">{isoLookup[isoCode]}</div>
  <CategoryBarVis {isoCode} />
</div>
